<template>
  <main role="main">
    <div class="block">
      <div class="mb-2">
        <span style="font-size: 1rem">按地区筛选 </span>
        <v-region @values="regionChange" :area="false" class="form-control"></v-region>
      </div>
      <div class="row">
        <div class="col-md-4" v-for="loc in locations" :key="loc.id">
          <!-- <a href @click="redirect(loc.url)">{{loc.nick}}</a> -->
          <router-link class="router-link" :to="{ name: 'HomePage', params: { url: loc.url }}">{{loc.province + (loc.city || '') + (loc.town || '')}}</router-link>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from 'axios'

export default {
  name: 'About',
  data () {
    return {
      locations: [],
      regions: []
    }
  },
  methods: {
    getLocations: function(region) {
      var that = this

      let url = '/common/govsite/list'
      if (region) {
        url += '?'
        if (region.province) {
          url += 'province=' + region.province.value
        }
        if (region.city) {
          url += '&city=' + region.city.value
        }
      }
      axios.get(this.$BASE_URL + url)
        .then(function (resp) {
          console.log('/common/govsite/list')
          console.log('axios', resp.data.data)
          that.locations = resp.data.data

          // let provinceSet = new Set(resp.data.data.map(p => p.province))
          // console.log(provinceSet)
        })
        .catch(function (error) {
          console.log('axios error', error)
        })

      this.$emit('updateInfo', {nick: '农销乐'})
    },
    redirect: function(url) {
      console.log('redirecting', url)
      this.$router.push({name: 'HomePage', params: { url: url }})
    },
    regionChange(data) {
      // console.log(data)
      this.getLocations(data)
    }
  },
  mounted: function () {
    // window.location.replace('https://nongxiao123.com')
    this.getLocations()
    // console.log('Entering About page')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.router-link {
  font-size: 1rem;
  line-height: 2.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue